import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './Countdown';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="bg-cream py-16 px-4 relative overflow-hidden border-t border-border" data-id="element-149">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-gold/5 rounded-full blur-[150px] pointer-events-none" data-id="element-150"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-151">
        <div className="text-center mb-10" data-id="element-152">
          <h2 className="text-lg md:text-2xl font-bold mb-4 flex items-center justify-center tracking-wide" style={{
          color: '#5C4A1F'
        }} data-id="element-153">
            <span className="mr-2" data-id="element-154">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <Countdown data-id="element-155" />
          <p className="text-ink mt-4 flex items-center justify-center text-sm md:text-base font-bold bg-urgency/10 inline-flex px-4 py-2 rounded-full border border-urgency/20" data-id="element-156">
            <span className="text-urgency mr-2" data-id="element-157">⚠️</span> Después sube el
            precio. No vuelve.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12" data-id="element-158">
          <div className="flex justify-between text-sm mb-2 text-ink font-bold" data-id="element-159">
            <span className="flex items-center" data-id="element-160">
              <span className="w-2 h-2 rounded-full bg-urgency mr-2 animate-pulse" data-id="element-161"></span>
              Cupos al precio de lanzamiento
            </span>
            <span data-id="element-162">68%</span>
          </div>
          <div className="w-full bg-surface rounded-full h-3 overflow-hidden border border-border" data-id="element-163">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-primary to-urgency h-3 rounded-full" data-id="element-164"></motion.div>
          </div>
          <p className="text-xs text-center text-muted mt-2 font-medium" data-id="element-165">
            68% de los cupos ya tomados
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-166">
          <motion.div whileHover={{
          y: -8
        }} className="bg-white rounded-2xl p-8 md:p-12 border-2 border-gold flex flex-col h-full shadow-[0_15px_40px_rgba(184,146,58,0.2)] relative" data-id="element-167">
            <div className="text-center mb-6" data-id="element-168">
              <h3 className="text-2xl md:text-3xl font-bold text-ink mb-2 flex items-center justify-center font-serif" data-id="element-169">
                <span className="mr-3" data-id="element-170">📘</span> TU INVERSIÓN HOY
              </h3>
              <p className="text-primary font-bold text-lg md:text-xl mb-2" data-id="element-171">
                CÓDIGO ALIMENTARIO COMPLETO
              </p>
              <p className="text-muted font-bold text-sm md:text-base mb-6" data-id="element-172">
                Producto Principal + 5 Bonos
              </p>
              <div className="bg-surface rounded-xl py-4 px-6 inline-block mb-2 border border-border/50" data-id="element-173">
                <p className="text-xs text-muted mb-1 uppercase tracking-wider font-bold" data-id="element-174">
                  Ideal para:
                </p>
                <p className="text-sm md:text-base font-medium text-ink" data-id="element-175">
                  Terapeutas que quieren intervenir con criterio, planificar en
                  minutos y lograr avances reales en sus casos de alimentación
                  infantil.
                </p>
              </div>
            </div>

            <div className="text-center mb-8 flex-grow" data-id="element-176">
              <p className="line-through text-lg md:text-xl mb-2 text-muted font-medium" data-id="element-177">
                $104.000
              </p>
              <div className="flex items-start justify-center" data-id="element-178">
                <span className="text-2xl md:text-3xl text-ink mt-1 mr-1 font-bold" data-id="element-179">
                  $
                </span>
                <span className="text-5xl md:text-7xl font-bold text-ink font-serif" data-id="element-180">
                  19.990
                </span>
                <span className="text-base md:text-2xl text-ink mt-auto mb-2 ml-2 font-bold" data-id="element-181">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://eureka-labs.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#F2D87A] via-[#C9A84C] to-[#8A6E2A] hover:from-[#F5DE8C] hover:via-[#D4B45A] hover:to-[#9A7E36] text-ink border border-[#8A6E2A]/50 font-bold py-5 px-6 rounded-full transition-all text-center text-base md:text-lg shadow-[0_8px_20px_rgba(138,110,42,0.35),inset_0_1px_0_rgba(255,255,255,0.5)] hover:scale-[1.02] active:scale-95 mb-3" data-id="element-182">
              🔥 SÍ, QUIERO MI CÓDIGO ALIMENTARIO AHORA
            </a>
            <p className="text-center text-sm font-bold text-muted uppercase tracking-wider" data-id="element-183">
              ACCESO INMEDIATO POR $19.990
            </p>
          </motion.div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-sm text-ink font-medium bg-white py-5 px-8 rounded-2xl border border-border max-w-4xl mx-auto shadow-sm" data-id="element-184">
          <div className="flex items-center" data-id="element-185">
            <Shield className="w-5 h-5 mr-2 text-success" data-id="element-186" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-187">
            <Lock className="w-5 h-5 mr-2 text-success" data-id="element-188" /> Pago seguro
          </div>
          <div className="flex items-center" data-id="element-189">
            <Zap className="w-5 h-5 mr-2 text-primary" data-id="element-190" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center w-full justify-center md:w-auto mt-2 md:mt-0" data-id="element-191">
            <CreditCard className="w-5 h-5 mr-2 text-primary" data-id="element-192" /> Mercado Pago |
            Tarjeta | Transferencia
          </div>
        </div>
      </div>
    </section>;
}